import React from 'react';
import TermsAndConditionsPageComponent from './terms-and-conditions.component';

function TermsAndConditionsPage() {
    return <TermsAndConditionsPageComponent />;
}

export default TermsAndConditionsPage;
